if(document.getElementById('joni-bar')){
const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;



const timer = document.getElementById('joni-bar').getAttribute('data-date');
const begin = document.getElementById('joni-bar').getAttribute('data-begin');
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const berlin = moment.tz(timer, "Europe/Berlin");
const berlinBegin = moment.tz(begin, "Europe/Berlin");
const myTz = berlin.clone().tz(timezone);
const myTzBegin = berlinBegin.clone().tz(timezone);

const hideCountDown = moment().diff(myTzBegin) < 0;

if(!hideCountDown) {
  console.log("Countdown wird angezeigt");
  $('#joni-bar').show();
}
  
const countDown = myTz.valueOf(),
      x = setInterval(function() {    
        const nowTemp = new Date();
        const now = nowTemp.getTime(),
              distance = countDown - now;

        document.getElementById("joni-days").innerText = Math.floor(distance / (day)),
          document.getElementById("joni-hours").innerText = Math.floor((distance % (day)) / (hour)),
          document.getElementById("joni-minutes").innerText = Math.floor((distance % (hour)) / (minute)),
          document.getElementById("joni-seconds").innerText = Math.floor((distance % (minute)) / second);

        //do something later when date is reached
        if (distance < 0) {
          document.getElementById("joni-headline").innerText = document.getElementById('joni-bar').getAttribute('data-finishtext');
          document.getElementById("joni-countdown").style.display = "none";
          clearInterval(x);
        }
        //seconds
      }, 0);
}


$(window).load(function() {
  loadProductDeliveryTimes();
  var els = $('div.grid--blog').children();
  console.log(els);
  console.log(getTallestHeight(els));
  els.height(getTallestHeight(els));
}); 

function getTallestHeight(elements) {
    var tallest = 0, height;

    for(const ele of elements) {
        height = $(ele).height();

        if(height > tallest) 
            tallest = height;
    }

    return tallest;
};

async function loadProductDeliveryTimes(){
  const res = await fetch('https://www.strictlylimitedgames.com/browsing_context_suggestions.json');
  const resJson = await res.json();
  const countryName = resJson.detected_values.country.name;
  const countryIso = resJson.detected_values.country.handle;

  const liveryMin = parseInt(countryData[countryIso].min);
  const liveryMax = parseInt(countryData[countryIso].max);
  console.log("Erkanntes Land:", countryIso);
  if(countryIso === 'US') $('#grctax').html('Excl. tax and shipping');
  $('#liveryPlaceholder').html(`Delivery to ${countryName}: ${liveryMin} to ${liveryMax} days`);
}

const countryData = {
   "AF": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "EG": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "AX": 
      {
         "min": "4",
         "max": "8"
      }
   ,
   "AL": 
      {
         "min": "16",
         "max": "20"
      }
   ,
   "DZ": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "VI": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "AS": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "AD": 
      {
         "min": "4",
         "max": "7"
      }
   ,
   "AO": 
      {
         "min": "10",
         "max": "16"
      }
   ,
   "AI": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "AG": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "GQ": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "AR": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "AM": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "AW": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "SH": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "AZ": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "ET": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "AU": 
      {
         "min": "11",
         "max": "21"
      }
   ,
   "BS": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "BH": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "BD": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "BB": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "BY": 
      {
         "min": "9",
         "max": "14"
      }
   ,
   "BE": 
      {
         "min": "2",
         "max": "4"
      }
   ,
   "BZ": 
      {
         "min": "13",
         "max": "19"
      }
   ,
   "BJ": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "BM": 
      {
         "min": "10",
         "max": "16"
      }
   ,
   "BT": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "BO": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "BQ": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "BA": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "BW": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "BV": 
      {
         "min": "7",
         "max": "8"
      }
   ,
   "BR": 
      {
         "min": "15",
         "max": "26"
      }
   ,
   "BN": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "BG": 
      {
         "min": "4",
         "max": "5"
      }
   ,
   "BF": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "BI": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "CL": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "CN": 
      {
         "min": "21",
         "max": "30"
      }
   ,
   "CK": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "CR": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "CI": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "CW": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "DK": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "DE": 
      {
         "min": "1",
         "max": "3"
      }
   ,
   "DM": 
      {
         "min": "14",
         "max": "16"
      }
   ,
   "DO": 
      {
         "min": "15",
         "max": "20"
      }
   ,
   "DJ": 
      {
         "min": "10",
         "max": "16"
      }
   ,
   "EC": 
      {
         "min": "15",
         "max": "20"
      }
   ,
   "SV": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "ER": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "EE": 
      {
         "min": "3",
         "max": "4"
      }
   ,
   "FK": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "FO": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "FJ": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "FI": 
      {
         "min": "4",
         "max": "8"
      }
   ,
   "FR": 
      {
         "min": "3",
         "max": "7"
      }
   ,
   "GF": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "PF": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "GA": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "GM": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "GE": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "GH": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "GI": 
      {
         "min": "4",
         "max": "7"
      }
   ,
   "GD": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "GR": 
      {
         "min": "6",
         "max": "14"
      }
   ,
   "GL": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "GB": 
      {
         "min": "2",
         "max": "6"
      }
   ,
   "GP": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "GU": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "GT": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "GG": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "GN": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "GW": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "GY": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "HT": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "HM": 
      {
         "min": "11",
         "max": "20"
      }
   ,
   "HN": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "HK": 
      {
         "min": "13",
         "max": "18"
      }
   ,
   "IN": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "ID": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "IQ": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "IR": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "IE": 
      {
         "min": "3",
         "max": "6"
      }
   ,
   "IS": 
      {
         "min": "14",
         "max": "16"
      }
   ,
   "IM": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "IL": 
      {
         "min": "16",
         "max": "22"
      }
   ,
   "IT": 
      {
         "min": "2",
         "max": "6"
      }
   ,
   "JM": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "JP": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "YE": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "JE": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "JO": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "VG": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "KY": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "KH": 
      {
         "min": "13",
         "max": "18"
      }
   ,
   "CM": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "CA": 
      {
         "min": "11",
         "max": "30"
      }
   ,
   "CV": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "KZ": 
      {
         "min": "8",
         "max": "15"
      }
   ,
   "QA": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "KE": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "KG": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "KI": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "CC": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "CO": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "KM": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "CD": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "CG": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "KP": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "KR": 
      {
         "min": "10",
         "max": "20"
      }
   ,
   "HR": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "CU": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "KW": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "LA": 
      {
         "min": "15",
         "max": "19"
      }
   ,
   "LS": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "LV": 
      {
         "min": "3",
         "max": "4"
      }
   ,
   "LB": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "LR": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "LY": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "LI": 
      {
         "min": "4",
         "max": "5"
      }
   ,
   "LT": 
      {
         "min": "3",
         "max": "4"
      }
   ,
   "LU": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "MO": 
      {
         "min": "11",
         "max": "16"
      }
   ,
   "MG": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "MW": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "MY": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "MV": 
      {
         "min": "12",
         "max": "16"
      }
   ,
   "ML": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "MT": 
      {
         "min": "4",
         "max": "6"
      }
   ,
   "MA": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "MH": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "MQ": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "MR": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "MU": 
      {
         "min": "10",
         "max": "20"
      }
   ,
   "YT": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "MX": 
      {
         "min": "10",
         "max": "20"
      }
   ,
   "FM": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "MD": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "MC": 
      {
         "min": "3",
         "max": "4"
      }
   ,
   "MN": 
      {
         "min": "12",
         "max": "19"
      }
   ,
   "ME": 
      {
         "min": "7",
         "max": "10"
      }
   ,
   "MS": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "MZ": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "MM": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "NA": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "NR": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "NP": 
      {
         "min": "10",
         "max": "4"
      }
   ,
   "NC": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "NZ": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "NI": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "NL": 
      {
         "min": "2",
         "max": "4"
      }
   ,
   "NE": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "NG": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "NU": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "MP": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "MK": 
      {
         "min": "7",
         "max": "15"
      }
   ,
   "NF": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "NO": 
      {
         "min": "7",
         "max": "8"
      }
   ,
   "OM": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "TL": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "AT": 
      {
         "min": "2",
         "max": "4"
      }
   ,
   "PK": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "PS": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "PW": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "PA": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "PG": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "PY": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "PE": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "PH": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "PN": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "PL": 
      {
         "min": "2",
         "max": "4"
      }
   ,
   "PT": 
      {
         "min": "3",
         "max": "8"
      }
   ,
   "PR": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "RE": 
      {
         "min": "11",
         "max": "14"
      }
   ,
   "RW": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "RO": 
      {
         "min": "3",
         "max": "4"
      }
   ,
   "RU": 
      {
         "min": "14",
         "max": "20"
      }
   ,
   "MF": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "BL": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "SB": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "ZM": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "WS": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "SM": 
      {
         "min": "5",
         "max": "8"
      }
   ,
   "ST": 
      {
         "min": "13",
         "max": "15"
      }
   ,
   "SA": 
      {
         "min": "9",
         "max": "13"
      }
   ,
   "SE": 
      {
         "min": "3",
         "max": "6"
      }
   ,
   "CH": 
      {
         "min": "3",
         "max": "6"
      }
   ,
   "SN": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "RS": 
      {
         "min": "7",
         "max": "10"
      }
   ,
   "SC": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "SL": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "ZW": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "SG": 
      {
         "min": "8",
         "max": "17"
      }
   ,
   "SX": 
      {
         "min": "10",
         "max": "13"
      }
   ,
   "SK": 
      {
         "min": "3",
         "max": "6"
      }
   ,
   "SI": 
      {
         "min": "3",
         "max": "6"
      }
   ,
   "SO": 
      {
         "min": "-",
         "max": "-"
      }
   ,
   "ES": 
      {
         "min": "2",
         "max": "5"
      }
   ,
   "LK": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "KN": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "LC": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "PM": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "VC": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "ZA": 
      {
         "min": "9",
         "max": "13"
      }
   ,
   "SD": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "SS": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "SR": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "SJ": 
      {
         "min": "7",
         "max": "8"
      }
   ,
   "SZ": 
      {
         "min": "9",
         "max": "13"
      }
   ,
   "SY": 
      {
         "min": "12",
         "max": "15"
      }
   ,
   "TJ": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "TW": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "TZ": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "TH": 
      {
         "min": "12",
         "max": "18"
      }
   ,
   "TG": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "TK": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "TO": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "TT": 
      {
         "min": "12",
         "max": "14"
      }
   ,
   "TD": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "CZ": 
      {
         "min": "2",
         "max": "3"
      }
   ,
   "TN": 
      {
         "min": "8",
         "max": "12"
      }
   ,
   "TR": 
      {
         "min": "10",
         "max": "15"
      }
   ,
   "TM": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "TC": 
      {
         "min": "14",
         "max": "19"
      }
   ,
   "TV": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "UG": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "UA": 
      {
         "min": "9",
         "max": "11"
      }
   ,
   "HU": 
      {
         "min": "3",
         "max": "5"
      }
   ,
   "UY": 
      {
         "min": "14",
         "max": "20"
      }
   ,
   "UZ": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "VU": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "VA": 
      {
         "min": "5",
         "max": "7"
      }
   ,
   "VE": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "AE": 
      {
         "min": "8",
         "max": "14"
      }
   ,
   "US": 
      {
         "min": "10",
         "max": "12"
      }
   ,
   "VN": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "WF": 
      {
         "min": "30",
         "max": "40"
      }
   ,
   "CX": 
      {
         "min": "11",
         "max": "15"
      }
   ,
   "CF": 
      {
         "min": "10",
         "max": "14"
      }
   ,
   "CY": 
      {
         "min": "10",
         "max": "15"
      }
   
};